<app-header2></app-header2>

<!-- <button class="btn-orange" (click)="confirmPayment()" style="margin: 100px;">Confirm</button> -->

<div class="container" style="margin-top:10%; margin-left: 20%;" ngi>
    <div *ngIf="!loading" class="row">
        <div class="jumbotron" style="box-shadow: 2px 2px 4px #000000;">
            <h2 class="text-center">{{responseText}}</h2>

            <p class="text-center">Your transaction # is: {{txnReference}}</p>
            <p *ngIf="approved" class="text-center">You will receive an payment confirmation email with details of your order.</p>
            <div class="btn-group" style="margin-top:50px; margin-left: 40%;">
                <button class="btn btn-lg btn-warning" (click)="continue()">{{BtnTxt}}</button>
            </div>
        </div>
    </div>

    <div *ngIf="loading" class="row">
        <div class="jumbotron" style="box-shadow: 2px 2px 4px #000000;">
            <h2 class="text-center">YOUR PAYMENT IS PROCESSING</h2>
            <h3 class="text-center">Please don't refresh the page!</h3>

            <!-- <p class="text-center">Your payment # is: {{txnReference}}</p> -->
            <div class="btn-group" style="margin-top:50px; margin-left: 40%;">
                <button class="buttonload">
                    <i class="fa fa-refresh fa-spin"></i>Loading
                </button>
            </div>
        </div>
    </div>
</div>